import React from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import {QuotationRequestSchema} from "../types";
import NotFound from "@ui-components/pages/NotFound";
import {NewQuotationDraft} from "../quotation-draft/new-quotation-draft";
import CountryContext from "../../../CountryContext";
import {useContext} from "react";
import AuthenticationService from "../../../services/AuthenticationService";
import { useHistory } from "react-router-dom";
import { useCheckKcolorProducts } from "@feature/commons/hooks/useCheckKcolorProducts";
import { SelectKcolorPriceModal } from "@feature/quotations/create-quotation-modal/components/select-kcolor-price-modal/component";
export const NewQuotationFromRequest= () => {
  const {country: {code}} = useContext(CountryContext);
  const { payload } = useParams<Record<string, string | undefined>>();
  const userScopes = AuthenticationService.getUserScopes();
  const history = useHistory();

  if (!userScopes.includes('quotation:create_draft')
  || !userScopes.includes('quotation:create'))
    // maybe handle permission error differently?
    return <NotFound />

  if (!payload) {
    return <NotFound />
  }
  const decodedPayload: QuotationRequestSchema = JSON.parse(atob(payload));
  const {
    agent,
    resale,
    enterprise,
    worksite,
    surveys
  } = decodedPayload;

  const [hasKcolorProducts, setHasKcolorProducts] = useState<boolean>(false);
  const [kColorPriceChoose, setKColorPriceChoose] = useState<"kerakoll" | "tintometer" | null >(null);

  const fetchKcolorProducts = useCheckKcolorProducts()

  fetchKcolorProducts(surveys.map(s=>s.id)).then((res: boolean) => {
    setHasKcolorProducts(res);
  });

  return (
    (hasKcolorProducts && kColorPriceChoose === null) ?
    <SelectKcolorPriceModal
      onConfirm={(v: "kerakoll" | "tintometer" ) => {
        setKColorPriceChoose(v);
      }}
      onExit={() => {
        history.push(`/${code}/worksites/${worksite.id}`);
      }}
    /> :
    <NewQuotationDraft
      worksite={worksite}
      surveys={surveys}
      agent={agent}
      enterprise={enterprise}
      resale={resale}
      onExit={() => {
        history.push(`/${code}/worksites/${worksite.id}`);
      }}
      kColorPriceChoose={kColorPriceChoose}
    />
  );
}